import { apiClient } from "./auth";
import type {
  GetOverviewExportHistoryResponse,
  GetOverviewExportStatusResponse,
  OverviewExportDeliveryMode,
  RequestOverviewExportResponse,
} from "./overviewExportTypes";

export interface TaskExportFilters {
  status?: string[];
  priority?: string[];
  workOrderType?: string[];
  assignedTo?: string;
  facilityId?: string[];
  isOverdue?: boolean;
  dueDateFrom?: string;
  dueDateTo?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  search?: string;
}

export interface RequestTaskExportPayload {
  email?: string;
  selectedColumnIds: string[];
  filters?: TaskExportFilters;
  deliveryMode?: OverviewExportDeliveryMode;
}

export async function requestTaskExportApi(
  payload: RequestTaskExportPayload
): Promise<RequestOverviewExportResponse> {
  const res = await apiClient.post<
    RequestTaskExportPayload,
    RequestOverviewExportResponse
  >("/overview/tasks/export", payload);
  return res.data;
}

export async function getTaskExportStatusApi(
  exportId: string
): Promise<GetOverviewExportStatusResponse> {
  const res = await apiClient.get<GetOverviewExportStatusResponse>(
    `/overview/tasks/export/${encodeURIComponent(exportId)}`
  );
  return res.data;
}

export async function getTaskExportHistoryApi(params?: {
  limit?: number;
  offset?: number;
}): Promise<GetOverviewExportHistoryResponse> {
  const query = new URLSearchParams();
  if (params?.limit != null) query.append("limit", String(params.limit));
  if (params?.offset != null) query.append("offset", String(params.offset));
  const url = query.toString()
    ? `/overview/tasks/export/history?${query.toString()}`
    : "/overview/tasks/export/history";
  const res = await apiClient.get<GetOverviewExportHistoryResponse>(url);
  return res.data;
}
